"use client";

import { useFetchTimer } from "@/hooks/useFetchTimer";
import { PawTimer } from "./paw-timer";

export function Countdown() {
  const { time, isLoading } = useFetchTimer();
  
  return (
    <div className=" flex gap-4 md:gap-8 justify-center">
      <PawTimer label="Minutes" value={time.minutes} isLoading={isLoading} />
      <PawTimer label="Seconds" value={time.seconds} isLoading={isLoading} />
      <PawTimer
        label="Milliseconds"
        value={time.milliseconds}
        isLoading={isLoading}
      />
    </div>
  );
}
